import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { PGHAppLoadService } from "src/app/core/core";
 
@Injectable({ providedIn: 'root' })
export class SiteConfigResolver  {
  constructor(private resourcesLoader: PGHAppLoadService) {}
  resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot): Observable<any> {
    return from(window['__bootstrapConfigPromise'] || Promise.resolve()).pipe(
      switchMap(() => {
        console.log("Site resources loaded");
        return this.resourcesLoader.loadSiteResources();
      })
    );
  }
}